import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cpfpipe'
})
export class CPFPipe implements PipeTransform {

    transform(cpf: string): string {
        if (cpf !== undefined && cpf !== null && cpf.length == 11) {
            return cpf.substring(0, 3) + '.' + cpf.substring(3, 6) + '.' + cpf.substring(6, 9) + '-' + cpf.substring(9, 11) } else {
            return '';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/_pipes/cpf.pipe.ts